import { Rect, Scale } from "../../MyHelpers";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { IUniReelPIXIAPP } from "./IUniReelPIXIPP";
import * as PIXI from "pixi.js";
import { UniReelPIXIAPP } from "./UniReelPIXIAPP";


export class FakeUniReelPIXIAPP implements IUniReelPIXIAPP {

    protected view: PIXI.Container = null;
    protected fakeSpine: PIXI.Container = null;
    protected reelsContainer: PIXI.Container = null;

    public constructor()
    {
    }

    Copy(): IUniReelPIXIAPP {
        return new FakeUniReelPIXIAPP();
    }

    GetReelsContainer(): PIXI.Container {
        return this.reelsContainer;
    }

    Create() {
        this.view = new PIXI.Container();
        this.view.name = "FakeUniReelPIXIAPP";

        this.fakeSpine = new PIXI.Container();
        this.fakeSpine.name = "FakeUniReelPIXIAPP-fakeSpine";
        this.fakeSpine.scale.set(0.6);
        this.view.addChild(this.fakeSpine);

        this.reelsContainer = new PIXI.Container();
        this.reelsContainer.name = "FakeUniReelPIXIAPP-ReelsContainer";
        this.fakeSpine.addChild(this.reelsContainer);
    }

    PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        return Promise.resolve();
    }

    ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        return Promise.resolve();
    }

    public GetView(): PIXI.Container {
        return this.view;
    }

    public GetReelsPosition(): Rect {
        const scale = 0.8;
        return new Rect(83 * scale, 0 * scale, 1735 * scale, 868 * scale);
    }

    public Destroy() {
    }

    public OnResize() {

    }
}